import { type FC, type ComponentProps } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { dibsLazyClient } from 'dibs-lazy/exports/dibsLazyClient.ts';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense.tsx';
import { Spinner } from 'dibs-elements/exports/Spinner.tsx';

const PdpSharedVimeoVideo = dibsLazyClient(
    () => import(/* webpackChunkName: "PdpSharedVimeoVideo" */ './PdpSharedVimeoVideo.tsx')
);

import classnames from 'classnames';
import dibsCss from 'dibs-css';

const Loading: FC = () => (
    <div
        className={classnames(
            dibsCss.flex,
            dibsCss.itemsCenter,
            dibsCss.justifyCenter,
            dibsCss.flexCol
        )}
    >
        <Spinner black size="small" />
        <span className={classnames(dibsCss.mtSmall, dibsCss.sassyFontSubHeaderMediumNormal)}>
            <FormattedMessage id="VimeoVideo.loadingVideo" defaultMessage="Video Loading" />
        </span>
    </div>
);

export const PdpSharedVimeoVideoLazy: FC<
    Omit<ComponentProps<typeof PdpSharedVimeoVideo>, 'id' | 'fallback'> & {
        id?: number | string | null;
    }
> = ({ id, ...props }) => {
    const vimeoId = id && typeof id === 'string' && parseInt(id);

    return vimeoId ? (
        <ClientSuspense fallback={<Loading />}>
            <PdpSharedVimeoVideo id={vimeoId} fallback={<Loading />} {...props} />
        </ClientSuspense>
    ) : (
        <Loading />
    );
};
